var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20ColoredDoc = function Svg20ColoredDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFA",
    d: "M13 2H7a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0A0A",
    strokeOpacity: 0.15,
    d: "M13 2.5H7A3.5 3.5 0 0 0 3.5 6v10A3.5 3.5 0 0 0 7 19.5h6a3.5 3.5 0 0 0 3.5-3.5V6A3.5 3.5 0 0 0 13 2.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACACAC",
    d: "M5.5 7h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5M5.5 9h6c.28 0 .5.22.5.5s-.22.5-.5.5h-6c-.28 0-.5-.22-.5-.5s.22-.5.5-.5M5.5 5h5c.28 0 .5.22.5.5s-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M13 20a4 4 0 0 0 4-4H3a4 4 0 0 0 4 4z"
  })));
};
export default Svg20ColoredDoc;